export const convertToTitleCase = (str?: string) => {
    return str?.toLowerCase().replace(/(^|\s)\S/g,
        (firstLetter) => firstLetter.toUpperCase());
}
export const convertToPascalCase = (str?: string) => {
   return str? str?.charAt(0).toUpperCase() + str?.slice(1):null;
};

